import React from 'react';
import styled from 'styled-components';
import { FormTextarea } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { companyNameIncludedOptions } from '../company/companyNameIncludedOptions';
import { PeriodSelector } from '../company/components/periodSelector';
import { useCompanyDomainFilter } from './useCompanyDomainFilter';

const FormTextareaWrapper = styled.div`
  & label + div {
    font-size: 12px;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.text.subtle};
  }
`;

export const CompanyDomainFilter = ({ value, companyNameIncluded, companyNamePeriod, setFilters }) => {
  const { formSchema, onSubmit, initialValues, formikRef } = useCompanyDomainFilter({
    setFilters,
    value,
    companyNameIncluded,
    companyNamePeriod,
  });

  return (
    <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <FormikAutoSubmit />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <FormTextareaWrapper>
              <Field
                name="companyDomain"
                label="Company"
                placeholder="company1.com www.company2.com https://company4.com ..."
                size="small"
                component={FormTextarea}
                rows={4}
                helpText="Enter company websites one per line or comma-separated."
              />
            </FormTextareaWrapper>
            <Field
              name="companyNameIncluded"
              component={FormExtraOptions}
              options={companyNameIncludedOptions}
              onChange={(option) => setFieldValue('companyNameIncluded', option)}
            />
            {values.companyNameIncluded?.value === 'specific_period' && (
              <PeriodSelector
                selected={values.companyNamePeriod}
                onSelect={(periodValues) => setFieldValue('companyNamePeriod', periodValues)}
              />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

CompanyDomainFilter.propTypes = {
  value: PropTypes.array,
  companyNameIncluded: PropTypes.object,
  companyNamePeriod: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

CompanyDomainFilter.defaultProps = {
  value: [],
  companyNameIncluded: null,
  companyNamePeriod: null,
};
